import { render, staticRenderFns } from "./ReasonWhy.vue?vue&type=template&id=24ed1b83&scoped=true&"
import script from "./ReasonWhy.vue?vue&type=script&lang=js&"
export * from "./ReasonWhy.vue?vue&type=script&lang=js&"
import style0 from "./ReasonWhy.vue?vue&type=style&index=0&id=24ed1b83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed1b83",
  null
  
)

export default component.exports